export interface KanbanViewHeaderI {
    title: string;
    total: string;
    name: string;
    position: number;
    duration: string;
    dropOff: string;
    dropOffHour: string;
}

export interface KanbanViewCardI {
    select: boolean;
    id: string;
    title: string;
    dueDate: string;
    priority: string;
    orderNumber: [];
    status: string;
    tagList: string[];
    smallImg: string;
    bigImg: string;
    estimated: string;
    assignee: string;
    assignedId: string;
    pinned: boolean;
    workOrderNo: string;
    workOrderId: string;
    designId: string;
}

export interface KanbanViewListI {
    id: string;                     
    header: KanbanViewHeaderI,
    cards: KanbanViewCardI[]; 
}
